import React, { useEffect, useMemo, useState } from 'react';
import styles from './PageLevelTabs.module.scss';
import Tabs from 'components/Functional/Tabs';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useRouter } from 'next/router';

type FieldItem = {
  id: string;
  fields: {
    title: {
      value: string;
    };
  };
};

type Props = ComponentProps & {
  fields: {
    items: FieldItem[];
  };
  anchorId?: string;
};

type QueryParams = {
  tab: string;
};

const PageLevelTabs: React.FC<Props> = ({ fields, rendering, anchorId }) => {
  const router = useRouter();
  const query = router.query as QueryParams;
  const [activeTab, setActiveTab] = useState<number | undefined>(undefined);

  const toggleTab = (tab: number) => {
    setActiveTab(tab);
    router.push(
      { pathname: window.location.pathname, query: tab ? { tab: tab + 1 } : '' },
      undefined,
      {
        shallow: true,
      }
    );
  };

  useEffect(() => {
    if (query.tab && router.isReady) {
      const tabIndex = +query.tab - 1;
      const tabsLength = fields.items.length - 1;
      setActiveTab(tabIndex > tabsLength ? tabsLength : tabIndex);
    }
  }, [router.isReady]);

  const selectedPlaceholder = useMemo(() => {
    return `abrdn-page-level-tab-${activeTab}`;
  }, [activeTab]);
  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`page-level-section background-white ${styles.pageLevelTabs}`}
    >
      <div className="container">
        <Placeholder rendering={rendering} name="abrdn-tiles-heading" />
      </div>

      <Tabs
        className={styles.pageLevelTabsOverflow}
        activeTab={activeTab}
        fields={fields}
        onTabChange={toggleTab}
      />

      {activeTab !== undefined && <Placeholder rendering={rendering} name={selectedPlaceholder} />}
    </section>
  );
};

export default PageLevelTabs;
